<div class="view-content" [ngClass]="{ 'fullscreen': fullscreen, 'centered-view': centered ,'view-content': true, 'no-padding': nopadding}"  [style.paddingBottom]="Layout.actionAreaHeight +'px'">
  <ng-content></ng-content>
</div>
